import React from 'react';
import { CheckOutlined } from '@ant-design/icons';

const BRAND      = '#0072CE';
const BRAND_LIGHT = '#e6f0fb';

interface TraductorStepsProps {
  total: number;
  current: number;
  stepsRef: React.RefObject<HTMLDivElement>;
  onStepClick: (index: number) => void;
}

const TraductorSteps: React.FC<TraductorStepsProps> = ({ total, current, stepsRef, onStepClick }) => {
  if (total <= 1) return null;

  return (
    <div
      ref={stepsRef}
      style={{
        display: 'flex',
        alignItems: 'center',
        overflowX: 'auto',
        paddingBottom: 4,
        scrollbarWidth: 'none',
      }}
    >
      {Array.from({ length: total }).map((_, i) => {
        const done   = i < current;
        const active = i === current;
        return (
          <React.Fragment key={i}>
            {i > 0 && (
              <div style={{
                flex: '1 1 24px',
                minWidth: 16,
                height: 2,
                background: i <= current ? BRAND : '#d9d9d9',
                transition: 'background .3s',
              }} />
            )}
            <div
              data-step={i}
              onClick={() => onStepClick(i)}
              style={{
                flexShrink: 0,
                width: 32,
                height: 32,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all .2s',
                background: done ? BRAND : active ? BRAND_LIGHT : '#fff',
                border: `2px solid ${done || active ? BRAND : '#d9d9d9'}`,
                color: done ? '#fff' : active ? BRAND : '#8c8c8c',
              }}
            >
              {done ? <CheckOutlined style={{ fontSize: 13 }} /> : String(i + 1).padStart(2, '0')}
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default TraductorSteps;
